// delLists/submitLists/actions.js

import { getDelLists } from "../../../api/DelApi";
import { submitsInitialState } from "./delListsSubmitListsState";
import { filtersInitialState } from "../../shared/filters/filtersState";
// Helper function for saving blob items
const saveBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const makeSubmitsActions = (set, get) => ({
  setSubmitsPage: ({ currentPage, pageSize }) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        submits: { ...s.delLists.submits, currentPage, pageSize },
      },
    })),

  setSubmitsPageSize: (pageSize) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        submits: { ...s.delLists.submits, pageSize, currentPage: 1 },
      },
    })),

  setSelectedSubmit: (submit) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        submits: { ...s.delLists.submits, selectedSubmit: submit },
      },
    })),

  toggleSelectedSubmit: (submitId) =>
    set((s) => {
      const current = s.delLists.submits.selectedSubmitIds || [];
      const exists = current.includes(submitId);
      const next = exists
        ? current.filter((i) => i !== submitId)
        : [...current, submitId];
      return {
        delLists: {
          ...s.delLists,
          submits: { ...s.delLists.submits, selectedSubmitIds: next },
        },
      };
    }),

  setSelectedSubmitIds: (submitIds) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        submits: { ...s.delLists.submits, selectedSubmitIds: submitIds },
      },
    })),

  clearSelectedSubmitIds: () =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        submits: { ...s.delLists.submits, selectedSubmitIds: [] },
      },
    })),

  resetSubmits: () =>
    set((s) => ({ delLists: { ...s.delLists, submits: submitsInitialState } })),

  fetchSubmitsPage: async (employeeId, overrideFilters) => {
    const {
      delLists: {
        submits: { currentPage, pageSize, filters, tableType },
      },
    } = get();
    const activeFilters = overrideFilters || filters || filtersInitialState();

    set((s) => ({
      delLists: {
        ...s.delLists,
        submits: { ...s.delLists.submits, loading: true, error: null },
      },
    }));

    try {
      const r = await getDelLists(
        employeeId,
        tableType,
        currentPage,
        pageSize,
        activeFilters
      );
      set((s) => ({
        delLists: {
          ...s.delLists,
          submits: {
            ...s.delLists.submits,
            loading: false,
            items: r.del_list,
            totalCount: r.total_count,
            needsUpdate: false,
            selectedSubmit: null,
          },
        },
      }));
    } catch (err) {
      console.error("Failed to fetch submits page:", err);
      set((s) => ({
        delLists: {
          ...s.delLists,
          submits: {
            ...s.delLists.submits,
            loading: false,
            error: err.message,
          },
        },
      }));
    }
  },
});
